export const drug_type = [
    { value: "Tablet", type: "Tab." },
    { value: "Capsule", type: "Cap." },
    { value: "Syrup", type: "Syrp." },
    { value: "Syrup", type: "Syrp." },
    { value: "Ointment", type: "Oint." },
    { value: "Suppository", type: "Suppo." },
    { value: "Cream", type: "Cream" },
    { value: "Injection", type: "Inj." },
    { value: "IM Injection", type: "IM Inj." },
    { value: "IV Injection", type: "IV Inj." },
    { value: "IV Injection", type: "IV Inj." },
    { value: "Eye Drops", type: "Eye Drops" },
    { value: "Ear Drop", type: "Ear Drop" },
    { value: "Aerosol Inhalation", type: "Aerosol Inhalation" },
    { value: "Blood Tubing Set", type: "Blood Tubing Set" },
    { value: "Blood bag", type: "Blood bag" },
    { value: "Bolus", type: "Bolus" },
    { value: "Butterfly", type: "Butterfly" },
    { value: "Chewable Tablet", type: "Chewable Tablet" },
    { value: "Combipack", type: "Combipack" },
    { value: "Cozycap", type: "Cozycap" },
    { value: "Cr Capsule", type: "Cr Capsule" },
    { value: "Cr Tablet", type: "Cr Tablet" },
    { value: "Delayed Release Capsule", type: "Delayed Release Capsule" },
    { value: "Dialysis Solution", type: "Dialysis Solution" },
    { value: "Dispersible Tablet", type: "Dispersible Tablet" },
    { value: "Dr Granules For Suspension", type: "Dr Granules For Suspension" },
    { value: "Dr Tablet", type: "Dr Tablet" },
    { value: "Drops", type: "Drops" },
    { value: "Dry Powder Inhaler", type: "Dry Powder Inhaler" },
    { value: "Ear Spray", type: "Ear Spray" },
    { value: "Effervescent Granules", type: "Effervescent Granules" },
    { value: "Effervescent Tablet", type: "Effervescent Tablet" },
    { value: "Elixir", type: "Elixir" },
    { value: "Emulgel", type: "Emulgel" },
    { value: "Emulsion", type: "Emulsion" },
    { value: "Er Capsule", type: "Er Capsule" },
    { value: "Er Tablet", type: "Er Tablet" },
    { value: "Extended Release Capsule", type: "Extended Release Cap." },
    { value: "Eye & Nasal Drops", type: "Eye & Nasal Drops" },
    { value: "Eye Cleanser Solution", type: "Eye Cleanser Solution" },
    { value: "Eye Gel", type: "Eye Gel" },
    { value: "Eye Ointment", type: "Eye Ointment" },
    { value: "Eye and Ear Drops", type: "Eye and Ear Drops" },
    { value: "Eye and Ear Ointment", type: "Eye and Ear Ointment" },
    { value: "Eye", type: "Eye" },
    { value: "Gargle & Mouth Wash", type: "Gargle & Mouth Wash" },
    { value: "Gas", type: "Gas" },
    { value: "Gel", type: "Gel" },
    { value: "Granules For Suspension", type: "Granules For Suspension" },
    { value: "Gum", type: "Gum" },
    { value: "Hand Rub", type: "Hand Rub" },
    { value: "Hfa Inhaler", type: "Hfa Inhaler" },
    { value: "IV Infusion", type: "IV Infusion" },
    { value: "IV/IM Injection", type: "IV/IM Injection" },
    { value: "Inhalation Aerosol", type: "Inhalation Aerosol" },
    { value: "Inhalation Capsule", type: "Inhalation Capsule" },
    { value: "Inhalation Liquid", type: "Inhalation Liquid" },
    { value: "Inhalation Solution", type: "Inhalation Solution" },
    { value: "Inhaler", type: "Inhaler" },
    { value: "Irrigation Solution", type: "Irrigation Solution" },
    { value: "Linctus", type: "Linctus" },
    { value: "Liquid", type: "Liquid" },
    { value: "Lotion", type: "Lotion" },
    { value: "M R Capsule", type: "M R Capsule" },
    { value: "M R Tablet", type: "M R Tablet" },
    { value: "Md Tablet", type: "Md Tablet" },
    { value: "Metered Dose Inhaler", type: "Metered Dose Inhaler" },
    { value: "Mouth Dissolving Tablet", type: "Mouth Dissolving Tablet" },
    { value: "Mouth Wash", type: "Mouth Wash" },
    { value: "Mouth Wash Antiseptic", type: "Mouth Wash Antiseptic" },
    { value: "Mups Tablet", type: "Mups Tablet" },
    { value: "Nasal Drops", type: "Nasal Drops" },
    { value: "Nasal Spray", type: "Nasal Spray" },
    { value: "Nebuliser Solution", type: "Nebuliser Solution" },
    { value: "Nebuliser Suspension", type: "Nebuliser Suspension" },
    { value: "Needle for Syringe", type: "Needle for Syringe" },
    { value: "Odt Tablet", type: "Odt Tablet" },
    { value: "Ophthalmic Emulsion", type: "Ophthalmic Emulsion" },
    { value: "Oral Dental Gel", type: "Oral Dental Gel" },
    { value: "Oral Drops", type: "Oral Drops" },
    { value: "Oral Emulsion", type: "Oral Emulsion" },
    { value: "Oral Gel", type: "Oral Gel" },
    { value: "Oral Granules", type: "Oral Granules" },
    { value: "Oral Liquid", type: "Oral Liquid" },
    { value: "Oral Paste", type: "Oral Paste" },
    { value: "Oral Powder", type: "Oral Pow." },
    { value: "Oral Saline", type: "Oral Saline" },
    { value: "Oral Soluble Film", type: "Oral Soluble Film" },
    { value: "Oral Solution", type: "Oral Solution" },
    { value: "Oral Suspension", type: "Oral Suspension" },
    { value: "Orodispersible Tablet", type: "Orodispersible Tablet" },
    { value: "Ors Tablet", type: "Ors Tablet" },
    { value: "Paediatric Drops", type: "Paediatric Drops" },
    { value: "Pellets", type: "Pellets" },
    { value: "Pellets For Suspension", type: "Pellets For Suspension" },
    { value: "Per Rectal", type: "Per Rectal" },
    { value: "Pour On (Solution)", type: "Pour On (Solution)" },
    { value: "Powder", type: "Pow." },
    { value: "Powder For Oral Solution", type: "Pow. For Oral Solution" },
    { value: "Powder For Suspension", type: "Pow. For Suspension" },
    { value: "Powder for Pedriatric Drop", type: "Pow. for Pedriatric Drop" },
    { value: "Powder for Solution", type: "Powder for Solution" },
    { value: "Pr Tablet", type: "Pr Tab." },
    { value: "Pvc Bag", type: "Pvc Bag" },
    { value: "Rapid Tablet", type: "Rapid Tablet" },
    { value: "Raw Materials", type: "Raw Materials" },
    { value: "Rectal Ointment", type: "Rectal Ointment" },
    { value: "Repacking", type: "Repacking" },
    { value: "Resperitory Solution", type: "Resperitory Solution" },
    { value: "Respirator Suspension", type: "Respirator Suspension" },
    { value: "Sached Powder", type: "Sached Powder" },
    { value: "Sachet", type: "Sachet" },
    { value: "Scalp Lotion", type: "Scalp Lotion" },
    { value: "Scalp Ointment", type: "Scalp Ointment" },
    { value: "Scrub", type: "Scrub" },
    { value: "Shampoo", type: "Shampoo" },
    { value: "Soft Gelatin Capsule", type: "Soft Gelatin Capsule" },
    { value: "Solution", type: "Sol." },
    { value: "Solution For Infusion", type: "Sol. For Infusion" },
    { value: "Solution For Injection", type: "Solution For Injection" },
    { value: "Spray", type: "Spray" },
    { value: "Sprinkle Capsule", type: "Sprinkle Cap." },
    { value: "Sr Capsule", type: "Sr Cap." },
    { value: "Sr Tablet", type: "Sr Tab." },
    { value: "Suspension", type: "Suspension" },
    { value: "Syringe", type: "Syringe" },
    { value: "Tincture", type: "Tincture" },
    { value: "Topical Solution", type: "Topical Solution" },
    { value: "Topical Suspension", type: "Topical Suspension" },
    { value: "Vaccine", type: "Vaccine" },
    { value: "Vaginal Cream", type: "Vaginal Cream" },
    { value: "Vaginal Gel", type: "Vaginal Gel" },
    { value: "Vaginal Pessary", type: "Vaginal Pessary" },
    { value: "Vaginal Suppository", type: "Vaginal Suppository" },
    { value: "Vaginal Tablet", type: "Vaginal Tablet" },
    { value: "Viscoelastic Solution", type: "Viscoelastic Solution" },
    { value: "Water For Injection", type: "Water For Injection" },
    { value: "Water Soluble Powder", type: "Water Soluble Powder" },
    { value: "Xr Tablet", type: "Xr Tablet" },
    { value: "Crystal", type: "Crystal" },
]